import {RTMSState} from '../_reducers/rtms';
import {RTMSConnectionState} from '../types';

type LocalState = {
    rtms: RTMSState;
};

export const getConnectedState = ({rtms}: LocalState): RTMSConnectionState => {
    return rtms.connectedState;
}

export const isConnected = ({rtms}: LocalState): boolean => {
    return rtms.connectedState === 'Connected';
}